import useGetCustomerFeatures from './useGetCustomerFeatures'

export default useGetCustomerFeatures
